import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showAlert, catchHandler } from "../../utils/helpers";

const state = {
    employees: [],
    employee: {
        employment:{},
        financial:{},
        attachments:{},
    },
    totalItems: 0,
    // ---------------------- //
    promotions: {
        totalItems: 0,
    },
    bonuses: {
        totalItems: 0,
    },
    degreeDelegnations: {
        totalItems: 0,
    },
    employeeDelegations: {
        totalItems: 0,
    },
    employeeTransfers: {
        totalItems: 0,
    }, 
    assignments: {
        totalItems: 0,
    },
};

const getters = {
    index: state => employeeId => state.employees.findIndex(i => i.employeeId === employeeId)
};

const mutations = {
    setEmployees: (state, r) => (state.employees = r),
    setTotalItems: (state, r) => (state.totalItems = r),

    setEmployee: (state, r) => (state.employee = r),
    setPromotions: (state, r) => (state.promotions = r),
    setBonuses: (state, r) => (state.bonuses = r),
    setDegreeDelegnations: (state, r) => (state.degreeDelegnations = r),
    setEmployeeDelegations: (state, r) => (state.employeeDelegations = r),
    setEmployeeTransfers: (state, r) => (state.employeeTransfers = r),
    setAssignments: (state, r) => (state.assignments = r),
};

const actions = {
    async getAll({ commit }, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");

            startLoading()
            const response = await dataService.search.getAll(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            commit("setEmployees", response.data.employees);
            commit("setTotalItems", response.data.totalItems);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },

    async getDetails({ commit }, id) {
        try {
            commit("setEmployee", {});
            startLoading()
            const response = await dataService.search.getDetails(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setEmployee", response.data.employee);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },

    async getImages(_, id) {
        try {
            startLoading()
            const response = await dataService.employees.getImages(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data.employee);


        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },

    //  ---------------------------------------------
    async getPromotions({ commit }, { id, params }) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");

            commit("setPromotions", {
                totalItems: 0,
            });
            startLoading()
            const response = await dataService.search.getPromotions(id, paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setPromotions", response.data.promotions);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    //  ---------------------------------------------
    async getBonuses({ commit }, { id, params }) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");

            commit("setBonuses", {
                totalItems: 0,
            });
            startLoading()
            const response = await dataService.search.getBonuses(id, paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setBonuses", response.data.bonuses);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    //  ---------------------------------------------
    async getDegreeDelegnations({ commit }, { id, params }) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");

            commit("setDegreeDelegnations", {
                totalItems: 0,
            });
            startLoading()
            const response = await dataService.search.getDegreeDelegnations(id, paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setDegreeDelegnations", response.data.degreeDelegnations);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    //  ---------------------------------------------
    async getEmployeeDelegations({ commit }, { id, params }) {
        try {
            commit("setEmployeeDelegations", {
                totalItems: 0,
            });
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");

            startLoading()
            const response = await dataService.search.getEmployeeDelegations(id, paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setEmployeeDelegations", response.data.employeeDelegations);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    //  ---------------------------------------------
    async getEmployeeTransfers({ commit }, { id, params }) {
        try {
            commit("setEmployeeTransfers", {
                totalItems: 0,
            });
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");

            startLoading()
            const response = await dataService.search.getEmployeeTransfers(id, paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setEmployeeTransfers", response.data.employeeTransfers);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    }, 
     //  ---------------------------------------------
    async getAssignments({ commit }, { id, params }) {
        try {
            commit("setAssignments", {
                totalItems: 0,
            });
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");

            startLoading()
            const response = await dataService.search.getAssignments(id, paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setAssignments", response.data.assignments);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
